import React, { useEffect, useState, useMemo } from "react";
import ReactTable from "react-table-v6";
import { Link, useLocation } from "react-router-dom";
import { formatDate } from "../../../../../../formatDate";
import commaNumber from "comma-number";
import Loader from "../../../../../../settings/loader";
import "react-table-v6/react-table.css";
import "./style.scss";
import { Cell } from "recharts";

function DetailedDiscountSlide(props) {
  const location = useLocation();
  const [data, setData] = useState({
    result: null,
    table: [],
  });
  const [discountsMap, setDiscountsMap] = useState({});
  const [discountsLoaded, setDiscountsLoaded] = useState(false);
  const [load, setLoad] = useState(0);
  const headers = {
    Authorization: props.user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  // Fetch discount details for chaKey
  // useEffect(() => {
  //   // if (!load) {
  //   async function fetchDiscounts() {
  //     if (props.data && props.data.length > 0) {
  //       const chaKey = props.data[0].chaKey;

  //       if (chaKey) {
  //         try {
  //           const res = await fetch(`/discounts/byChaKey/${chaKey}`);
  //           const discounts = await res.json();
  //           console.log("Fetched discounts for chaKey:", discounts);
  //           // Map discountNo/display to discountName for quick lookup
  //           const map = {};
  //           // discounts is an array, check if it has discounts property
  //           if (Array.isArray(discounts) && discounts[0]?.discounts) {
  //             discounts[0].discounts.forEach((d) => {
  //               map[d.discNumber] = d.discName;
  //             });
  //           } else if (discounts?.discounts) {
  //             // If single object response
  //             discounts.discounts.forEach((d) => {
  //               map[d.discNumber] = d.discName;
  //             });
  //           }
  //           // discounts.forEach((d) => {
  //           //   map[d.display] = d.discountName;
  //           // });
  //           setDiscountsMap(map);
  //         } catch (e) {
  //           setDiscountsMap({});
  //         }
  //       }
  //     }
  //   }
  //   fetchDiscounts();
  //   // }
  // }, [props.data]);
  // Fetch discount details for chaKey
  // useEffect(() => {
  //   async function fetchDiscounts() {
  //     if (props.data && props.data.length > 0) {
  //       const chaKey = props.data[0].chaKey;

  //       if (chaKey) {
  //         try {
  //           // Try with full URL or check what baseURL should be
  //           const url = `${props.chimeraserv.urlGet}/discounts/byChaKey/${chaKey}`;

  //           const res = await fetch(url, { headers });

  //           if (!res.ok) {
  //             console.error("Fetch failed with status:", res.status);
  //             setDiscountsMap({});
  //             return;
  //           }

  //           const discounts = await res.json();

  //           // Map discNumber to discName for quick lookup
  //           const map = {};

  //           // discounts is an array, check if it has discounts property
  //           if (Array.isArray(discounts) && discounts[0]?.discounts) {
  //             discounts[0].discounts.forEach((d) => {
  //               map[d.discNumber] = d.discName;
  //             });
  //           } else if (discounts?.discounts) {
  //             // If single object response

  //             discounts.discounts.forEach((d) => {
  //               map[d.discNumber] = d.discName;
  //             });
  //           } else {
  //             console.log(
  //               "No discounts structure found. discounts data:",
  //               discounts
  //             );
  //           }

  //           setDiscountsMap(map);
  //         } catch (e) {
  //           console.error("Error fetching discounts:", e);
  //           setDiscountsMap({});
  //         }
  //       } else {
  //         console.log("No chaKey found");
  //       }
  //     } else {
  //       console.log("props.data is empty or not available");
  //     }
  //   }

  //   fetchDiscounts();
  // }, [props.data]);

  useEffect(() => {
    async function fetchDiscounts() {
      setDiscountsLoaded(false);
      if (!props.data || !props.data.length) {
        setDiscountsMap({});
        setDiscountsLoaded(true);
        return;
      }
      const chaKeys = [
        ...new Set(props.data.map((r) => r.chaKey).filter(Boolean)),
      ];
      const map = {};

      await Promise.all(
        chaKeys.map(async (chaKey) => {
          try {
            const url = `${props.chimeraserv.urlGet}/discounts/byChaKey/${chaKey}`;
            const res = await fetch(url, { headers });
            if (!res.ok) return;
            const discounts = await res.json();
            const list =
              Array.isArray(discounts) && discounts[0]?.discounts
                ? discounts[0].discounts
                : discounts?.discounts || [];

            list.forEach((d) => {
              // compound key ensures unique lookup per outlet
              map[`${chaKey}_${d.discNumber}`] = d.discName;
              // keep numeric-only key as fallback if you still want it
              if (!(d.discNumber in map)) map[d.discNumber] = d.discName;
            });
          } catch (e) {
            // ignore individual fetch errors
          }
        })
      );

      setDiscountsMap(map);
      setDiscountsLoaded(true);
    }

    fetchDiscounts();
  }, [props.data]);
  // Initialize data when props.data changes
  useEffect(() => {
    if (props.data && !load) {
      setData((prev) => ({
        ...prev,
        result: {
          discountDetails: props.data,
          ...props.filter?.data,
          ...props.data,
        },
      }));

      setLoad(1);
    }

    // eslint-disable-next-line
  }, [props.data, props.filter, load]);

  // Prepare table data when result is set

  useEffect(() => {
    if (load === 1 && data.result && discountsLoaded) {
      const details = data.result.discountDetails || [];
      const chains = data.result.chains || [];
      const brands = data.result.brands || [];
      const table = details.map((row) => {
        // Find chain and brand names
        const chainObj = chains.find((c) => c.chaKey === row.chaKey);
        const brandObj = brands.find((b) => b.braKey === row.braKey);
        const businessName =
          (brandObj?.name || "") +
          (chainObj?.name ? " - " + chainObj.name : "");

        // Employees comma separated
        const employees =
          Array.isArray(row.emp) && row.emp.length
            ? row.emp
                .map((e) => e.name)
                .filter(Boolean)
                .join(", ")
            : "";

        // Discount type logic
        let discountType = "";
        let discountName = "";
        if (row.discountNumber && row.discountNumber !== 0) {
          discountType = "Check";
          const chainKey = `${row.chaKey}_${row.discountNumber}`;
          const fallbackKey = row.discountNumber;
          const found = discountsMap[chainKey] || discountsMap[fallbackKey];
          if (row.discountType === "COUPON") {
            discountName = found || `Coupon #${row.discountNumber}`;
          } else {
            discountName = found || `Discount #${row.discountNumber}`;
          }
        }
        // if (row.discountNumber && row.discountNumber !== 0) {
        //   discountType = "Check";
        //   console.log("Processing discount for debugging:", discountsMap);
        //   // If discountType is COUPON, check for type === 1
        //   if (row.discountType === "COUPON") {
        //     discountName =
        //       discountsMap[row.discountNumber] ||
        //       `Coupon #${row.discountNumber}`;
        //   } else {
        //     // For other types
        //     discountName =
        //       discountsMap[row.discountNumber] ||
        //       `Discount #${row.discountNumber}`;
        //   }
        // }
        if (
          Array.isArray(row.items) &&
          row.items.some(
            (item) =>
              item.discount &&
              item.discount.discountNo &&
              item.discount.discountNo !== 0
          )
        ) {
          discountType = discountType ? discountType + ", Item" : "Item";
        }
        if (
          Array.isArray(row.items) &&
          row.items.some(
            (item) =>
              item.discount &&
              item.discount.discountAmt &&
              item.discount.discountNo === 0 &&
              item.discount.discountAmt !== 0 &&
              !row.discountNumber
          )
        ) {
          discountType = discountType ? discountType + ", Check" : "Check";
        }

        // Calculate gross amount (sum of all item amounts * quantity)
        let grossAmount = 0;
        if (Array.isArray(row.items)) {
          row.items.forEach((item) => {
            if (item.amount) {
              grossAmount += item.amount * (item.qty || 1);
            }
          });
        }

        // Calculate discount as gross amount - total
        const discount = grossAmount - row.total;

        return {
          businessName,
          date: row.date,
          billNo: row.billNo,
          total: row.total,
          grossAmount: grossAmount,
          discount: discount,
          employee: employees,
          discountType,
          discountName,
          _id: row._id,
        };
      });

      setData((prev) => ({
        ...prev,
        table,
      }));
      setLoad(2);
    }
    // eslint-disable-next-line
  }, [load, data.result, discountsMap, discountsLoaded]);
  // Export logic
  useEffect(() => {
    if (props.export && data.table.length) {
      props.getData({
        type: "table",
        title: "Detailed Discount Summary",
        filter: {
          brands: props.filter.data.brands.map((brand) => brand.name),
          chains: props.filter.data.chains.map((chain) => chain.name),
          revCent: props.filter.data.revCent.map((revCent) => revCent.name),
          payType: props.filter.data.payType.map((payType) => payType.name),
          date: {
            start: props.filter.data.date.start,
            end: props.filter.data.date.end,
          },
        },
        body: [
          {
            head: [
              [
                "Business Name",
                "Date",
                "Order No",
                "Gross Amount",
                "Discount",
                "Total",
                "Employee",
                "Applied To",
                "Discount Name",
              ],
            ],
            body: data.table.map((value) => [
              value.businessName,
              value.date ? formatDate.longShort(value.date) : "",
              value.billNo,
              typeof value.grossAmount === "number"
                ? data.result.groups[0].baseCurr.toUpperCase() +
                  " " +
                  commaNumber(value.grossAmount.toFixed(2))
                : "",
              typeof value.discount === "number"
                ? data.result.groups[0].baseCurr.toUpperCase() +
                  " " +
                  commaNumber(value.discount.toFixed(2))
                : "",
              typeof value.total === "number"
                ? data.result.groups[0].baseCurr.toUpperCase() +
                  " " +
                  commaNumber(value.total.toFixed(2))
                : "",
              value.employee,
              value.discountType,
              value.discountName || "",
            ]),
          },
        ],
      });
    }
    // eslint-disable-next-line
  }, [props.export, data.table, props.getData, props.filter]);

  function sortDiscounts(a, b) {
    if (parseInt(a.date) > parseInt(b.date)) return -1;
    if (parseInt(a.date) < parseInt(b.date)) return 1;
    return 0;
  }

  const renderLink = (rowData, displayValue) => {
    // Ensure we have the necessary data
    if (!rowData || !rowData._id) {
      return displayValue || "";
    }

    const billNo = rowData.billNo;

    // Collect all discount names and types for this billNo
    let discountsForBill = data.table
      .filter((row) => row.billNo === billNo)
      .map((row) => ({
        discountName: row.discountName,
        type: row.type,
      }));

    // Remove duplicates where both discountName and type are equal
    discountsForBill = discountsForBill.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          (d) => d.discountName === item.discountName && d.type === item.type
        )
    );

    return (
      <Link
        to={`/${location.pathname.split("/")[1]}/view/${
          location.pathname.split("/")[3]
        }/${rowData._id}`}
        state={{
          prevUrl: location.pathname,
          data: rowData,
          filter: props.filter,
        }}
      >
        {displayValue || ""}
      </Link>
    );
  };

  // Unique discount names for filter dropdown
  const uniqueDiscountNames = useMemo(() => {
    if (!data.table) return [];
    return [...new Set(data.table.map((table) => table.discountName))];
  }, [data.table]);

  const columns = [
    {
      Header: "Business Name",
      accessor: "businessName",
      Cell: (row) => {
        return renderLink(row.row._original, row.value || "");
      },
    },
    {
      Header: "Date",
      accessor: "date",
      Cell: (row) => {
        return renderLink(
          row.row._original,
          row.value ? formatDate.longShort(row.value) : ""
        );
      },
    },
    {
      Header: "Order No",
      accessor: "billNo",
      Cell: (row) => {
        return renderLink(row.row._original, row.value || "");
      },
    },
    {
      Header: "Gross Amount",
      accessor: "grossAmount",
      Cell: (row) => {
        const displayValue =
          typeof row.value === "number"
            ? data.result.groups[0].baseCurr.toUpperCase() +
              " " +
              commaNumber(row.value.toFixed(2))
            : "";

        return renderLink(row.row._original, displayValue);
      },
    },
    {
      Header: "Discount",
      accessor: "discount",
      Cell: (row) => {
        const displayValue =
          typeof row.value === "number"
            ? data.result.groups[0].baseCurr.toUpperCase() +
              " " +
              commaNumber(row.value.toFixed(2))
            : "";

        return renderLink(row.row._original, displayValue);
      },
    },
    {
      Header: "Total",
      accessor: "total",
      Cell: (row) => {
        const displayValue =
          typeof row.value === "number"
            ? data.result.groups[0].baseCurr.toUpperCase() +
              " " +
              commaNumber(row.value.toFixed(2))
            : "";

        return renderLink(row.row._original, displayValue);
      },
    },
    {
      Header: "Employee",
      accessor: "employee",
      Cell: (row) => {
        return renderLink(row.row._original, row.value || "");
      },
    },
    {
      Header: "Applied To",
      accessor: "discountType",
      Cell: (row) => {
        return renderLink(row.row._original, row.value || "");
      },
    },
    {
      Header: "Discount Name",
      accessor: "discountName",
      Cell: (row) => {
        return renderLink(row.row._original, row.value || "");
      },
    },
  ];
  return (
    <div>
      {load < 2 ? (
        <Loader />
      ) : data.table.length === 0 ? (
        <div style={{ textAlign: "center", padding: "24px 0" }}>
          No discount details found.
        </div>
      ) : (
        <ReactTable
          className="-striped -highlight"
          data={data.table}
          columns={columns}
          sortable
          filterable
          getTdProps={() => ({
            style: {
              textAlign: "center",
            },
          })}
        />
      )}
    </div>
  );
}

export default DetailedDiscountSlide;
